const locationSearch = typeof window !== 'undefined' ? window.location.search : '';
export const QUERY_VERSION = new URLSearchParams(locationSearch).get('version') ?? '2.0.0';

export const IS_TIER3_PAGE = new URLSearchParams(locationSearch).has('isdealer');

export const CARFAX_ICON =
  'https://nar.media.audi.com/is/image/audinar/nemo/ca/NoMo/collaboration/wormwod/ui/carfax.png';
export const TEST_DIRVE_ICON =
  'https://nar.media.audi.com/is/content/audinar/nemo/ca/NoMo/collaboration/wormwod/ui/test-drive-small.svg';
export const USED_CAR_SEARCH_ICON =
  'https://nar.media.audi.com/is/content/audinar/nemo/ca/NoMo/collaboration/wormwod/ui/used-car-search-small.svg';
export const MOTOR_ICON =
  'https://nar.media.audi.com/is/content/audinar/nemo/ca/NoMo/collaboration/wormwod/ui/motor-small.svg';
export const TOP_SPEED_ICON =
  'https://nar.media.audi.com/is/content/audinar/nemo/ca/NoMo/collaboration/wormwod/ui/top-speed-small.svg';
export const QUATTRO_ICON =
  'https://nar.media.audi.com/is/content/audinar/nemo/ca/NoMo/collaboration/wormwod/ui/quattro-small.svg';
export const BREAK_PAD_ICON =
  'https://nar.media.audi.com/is/content/audinar/nemo/ca/NoMo/collaboration/wormwod/ui/break-pad-small.svg';
export const CHARGE_LEVEL_HALF_ICON =
  'https://nar.media.audi.com/is/content/audinar/nemo/ca/NoMo/collaboration/wormwod/ui/electric-charge-level-half-small.svg';
export const TRANSMISSION_ICON =
  'https://nar.media.audi.com/is/content/audinar/nemo/ca/NoMo/collaboration/wormwod/ui/transmission-small.svg';
export const CHARGE_LEVEL_ICON =
  'https://nar.media.audi.com/is/content/audinar/nemo/ca/NoMo/collaboration/wormwod/ui/charge-level-small.svg';
export const VEHICLE_SIGNAL_ICON =
  'https://nar.media.audi.com/is/content/audinar/nemo/ca/NoMo/collaboration/wormwod/ui/vehicle-signal-small.svg';

export enum StatImport {
  AGC_USA_JDP = 'AGC_USA_JDP',
  AGC_CAN_JDP = 'AGC_CAN_JDP',
}

export enum CarTypes {
  NEW = 'NEW',
  USED = 'USED',
}

export enum Market {
  US = 'us',
  CA = 'ca',
}
